import { baseLottoUrl } from "../../services/api";
import React, { useContext } from "react";

// import PopupArt1 from "../../assets/bitcoinyay-popup/art-1.png";
// import PopupLogo from "../../assets/bitcoinyay-popup/logo.png";
// import PopupButton from "../../assets/bitcoinyay-popup/button.png";
// import PopupArt2 from "../../assets/bitcoinyay-popup/token.png";

import PopupArt1 from "../../assets/bitcoinyay-popup/airdrop-popup-1.webp";

import freeTicket from "../../assets/homepage/iusdup.svg";
import Promo2 from "../../assets/homepage/promo2.png";
import btcIcon from "../../assets/homepage/btc_ai_icon.svg";
// import wis from "../../assets/homepage/wis_banner.svg";
import wisImg from "../../assets/popup/14JulyImg.png";
import wisText from "../../assets/popup/hot-summer.svg";
import indexxShop from "../../assets/popup/new popup dec 2024.svg";
import flower from "../../assets/homepage/flower.png";
import btcText from "../../assets/homepage/btc_popup_text.svg";
import indexxLogo from "../../assets/homepage/indexx_logo_white.svg";
import inexLogo from "../../assets/homepage/iusddown.svg";
import { useNavigate } from "react-router-dom";
import CrossIcon from "../../assets/homepage/updated/cross_white.png";
import { Popup } from "../../utils/PopupContest";
const Modal = ({ show, onClose }) => {
  let navigate = useNavigate();
  const { setPopup } = useContext(Popup);
  const [isLinkHovered, setIsLinkHovered] = React.useState(false);
  const handleLinkMouseEnter = () => {
    setIsLinkHovered(true);
  };
  const handleLinkMouseLeave = () => {
    setIsLinkHovered(false);
  };

  // const firstPromoHandler = () => {
  //   window.location.href =
  //     `${baseLottoUrl}/contest-details?uniqueCode=WFE500`;
  // };

  const firstPromoHandler = () => {
    const expiration = new Date().getTime() + 30 * 60 * 1000; // 30 minutes from now
    localStorage.setItem("expirationTime", String(expiration));
    setPopup(false);
    onClose();
    // navigate("/airdrop-dacrazy");
    window.location.href = "/#celebration-banner";
  };
  const closePopupHandler = () => {
    const expiration = new Date().getTime() + 30 * 60 * 1000; // 30 minutes from now
    localStorage.setItem("expirationTime", String(expiration));
    setPopup(false);
    onClose();
  };

  return (
    <>
      {show && (
        <div className="modal-backdrop" onClick={closePopupHandler}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div
              className="modal-body"
              style={{
                width: "100%",
                maxWidth: "1000px",
                margin: "auto",
                position: "relative",
              }}
            >
              <div className="modals-container text-center">
                <button
                  className="close-btn-modl"
                  onClick={() => closePopupHandler()}
                >
                  <img src={CrossIcon} alt="indexx cross icon" />
                </button>
                {/* <div className="modals-item" style={{ background: "#D9FAFF" }}>
                  <button
                    className="close-btn-modl"
                    onClick={() => onClose(false)}
                  >
                    X
                  </button>

                  <div style={{ background: "#0155EE", padding: "5px 0px" }}>
                    <img src={indexxLogo} alt="Image 1" height={42} />
                  </div>
                  <div>
                    <img src={freeTicket} alt="Image 1" width="90%" />
                  </div>
                  <div>
                    <img src={inexLogo} alt="Image 1" />
                  </div>
                  <br />
                  <br />

                  <button
                    onClick={firstPromoHandler}
                    className="modals-button"
                    style={{ background: "#004DCD", borderRadius: "2px" }}
                  >
                    Participate Now
                  </button>
                </div> */}
                {/* <div className="modals-item" style={{ background: "#000" }}>
                  <div style={{ background: "#0155EE", padding: "22px 0px" }}>
                    <img src={indexxLogo} alt="Image 1" height={42} />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "50px 10px",
                    }}
                  >
                    <div>
                      <img src={btcIcon} alt="Image 1" width="90%" />
                    </div>
                    <div>
                      <img src={btcText} alt="Image 1" />
                    </div>
                  </div>

                  <br />
                  <br />

                  <button
                    onClick={secondPromoHandler}
                    className="modals-button"
                    style={{ background: "#F59219", borderRadius: "2px" }}
                  >
                    Participate Now
                  </button>
                </div> */}
                {/* <div
                  className="modals-item"
                  style={{
                    background: "#141414",
                    overflow: "hidden",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "90%",
                    maxWidth: "600px",
                    margin: "0 auto",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    <img
                      src={PopupArt1}
                      alt="Popup Art 1"
                      style={{
                        width: "100%",
                      }}
                    />
                    <img
                      src={PopupLogo}
                      alt="Popup Logo"
                      style={{
                        width: "90%",
                        maxWidth: "340px",
                        marginTop: "0px",
                      }}
                    />
                    <h2
                      style={{
                        fontSize: window.innerWidth > 768 ? "48px" : "36px",
                        fontWeight: "bold",
                        textAlign: "center",
                        marginTop: "16px",
                        color: "#FFFFFF",
                      }}
                    >
                      We've Hit <span style={{ color: "#FC9239" }}>10K</span>{" "}
                      Miners!
                    </h2>
                    <p
                      style={{
                        fontSize: window.innerWidth > 768 ? "26px" : "18px",
                        textTransform: "uppercase",
                        fontWeight: "600",
                        marginTop: "16px",
                        textAlign: "center",
                        padding: "0 8px",
                        color: "#EBEBEB",
                      }}
                    >
                      Only <span style={{ color: "#FC9239" }}>21 days</span>{" "}
                      since launch - join the fastest-growing mining app today!
                    </p>
                    <img
                      src={PopupButton}
                      alt="Popup Button"
                      onClick={firstPromoHandler}
                      style={{
                        marginTop: "24px",
                        marginBottom:
                          window.innerWidth > 768 ? "96px" : "120px",
                        width: "288px",
                        cursor: "pointer",
                        transform: isLinkHovered ? "scale(1.05)" : "scale(1)",
                        transition: "transform 0.3s ease-in-out",
                      }}
                      onMouseEnter={handleLinkMouseEnter}
                      onMouseLeave={handleLinkMouseLeave}
                    />
                    <img
                      src={PopupArt2}
                      alt="Popup Art 2"
                      style={{
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                      }}
                    />
                  </div>
                </div> */}
                <div
                  style={{
                    paddingTop: "40px",
                    paddingBottom: "40px",
                    background: "#141414",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={PopupArt1}
                    alt="Popup Art 1"
                    style={{
                      width: "90%",
                      maxWidth: "600px",
                      objectFit: "cover",
                    }}
                  />
                  <button
                    onClick={firstPromoHandler}
                    onMouseEnter={handleLinkMouseEnter}
                    onMouseLeave={handleLinkMouseLeave}
                    style={{
                      marginTop: "20px",
                      borderRadius: "8px",
                      width: "200px",
                      background: "transparent",
                      color: "#FC9239",
                      padding: "10px 20px",
                      fontSize: "20px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      border: "2px solid #FC9239",
                      transform: isLinkHovered ? "scale(1.05)" : "scale(1)",
                      transition: "transform 0.3s ease-in-out",
                    }}
                  >
                    COUNT ME IN
                  </button>
                </div>
                {/* <div className="modals-item" style={{ background: "black" }}>
                  <div style={{ height: "400px" }}>
                    <img
                      src={Promo2}
                      alt="Image 2"
                      className="modals-image"
                      style={{ paddingBottom: "20px" }}
                    />
                  </div>
                  <button
                    onClick={secPromoHandler}
                    className="modals-button"
                    style={{ background: "#f59219", borderRadius: "2px" }}
                  >
                    Participate Now
                  </button>
                </div> */}
                {/* <div className="modals-item" style={{ background: "#F7F0FD" }}>
                  <div style={{ height: "400px" }}>
                    <img src={Promo3} alt="Image 3" className="modals-image" />
                  </div>
                  <button
                    onClick={thirdPromoHandler}
                    className="modals-button-blue"
                  >
                    Participate Now
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
